import { createSlice } from "@reduxjs/toolkit";
import TimeWindowGroupList from "src/pages/in-app/time-window-group-list/TimeWindowGroupList";
import { TimeWindowGroupPatchInDto } from "src/repositories/api/time-window-group/dto/Dto";
import { removeUndefined } from "src/utils/Utils";

const timeWindowGroupListSlice = createSlice({
  name: "timeWindowGroup-list",
  initialState: null as TimeWindowGroup[] | null,
  reducers: {
    update: (_list, action: { payload: TimeWindowGroup[] | null }) =>
      action.payload,
    add: (list, action: { payload: TimeWindowGroup[] }) => {
      if (list == null) {
        return;
      }
      list.push(...action.payload);
    },
    remove: (list, action: { payload: number[] }) => {
      const removedSns = action.payload;
      if (list == null) {
        return;
      }
      return list.filter(
        (timeWindowGroup) =>
          removedSns.find((sn) => timeWindowGroup.id == sn) == null
      );
    },
    patchItem: (
      list,
      action: { payload: TimeWindowGroupPatchInDto & { id: number } }
    ) => {
      if (list == null) {
        return;
      }
      const newTimeWindowGroup = action.payload;
      const index = list.findIndex((g) => g.id == newTimeWindowGroup.id);
      if (index == null) {
        return;
      }

      list[index] = { ...list[index], ...removeUndefined(newTimeWindowGroup) };
    },
    addEditItems: (list, action: { payload: TimeWindowGroup[] }) => {
      if (list == null) {
        return;
      }
      action.payload.forEach((twg) => {
        const index = list.findIndex((item) => item.id == twg.id);
        if (index != -1) {
          list[index] = twg;
        } else {
          list.push(twg);
        }
      });
    },
  },
});

export default timeWindowGroupListSlice;
